import { isDevelop } from '../utils';

export const GCS_BUCKET = isDevelop() ? 'mocky-data-dev' : 'mocky-data';

export const SYSTEM_VERSION = '1.0.0';
export const DIAGRAM_VERSION = '1.0.0';
export const ICON_VERSION = '1.0.0';
export const TEMPLATE_VERSION = '1.0.0';

export const SYSTEMS = [
  {
    categoryName: 'Common',
    groupId: 'Common-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'Shapes',
    groupId: 'Shapes-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'Charts',
    groupId: 'Charts-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'Devices',
    groupId: 'Devices-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'IOS',
    groupId: 'IOS-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'Web',
    groupId: 'Web-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'Avatar',
    groupId: 'Avatar-systemCategory',
    componentList: [],
    type: 'systemList',
  },

  {
    categoryName: 'Bootstrap',
    groupId: 'Bootstrap-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'Ionic',
    groupId: 'Ionic-systemCategory',
    componentList: [],
    type: 'systemList',
  },
  {
    categoryName: 'Android',
    groupId: 'Android-systemCategory',
    componentList: [],
    type: 'systemList',
  },
];

export const DIAGRAMS = [
  {
    categoryName: 'Flowchart',
    groupId: 'Flowchart-diagramCategory',
    componentList: [],
    type: 'diagramList',
  },
  {
    categoryName: 'Shapes',
    groupId: 'Shapes-diagramCategory',
    componentList: [],
    type: 'diagramList',
  },
  {
    categoryName: 'Container',
    groupId: 'Container-diagramCategory',
    componentList: [],
    type: 'diagramList',
  },
  {
    categoryName: 'Network',
    groupId: 'Network-diagramCategory',
    type: 'diagramList',
    subCategoryList: [
      {
        categoryName: 'Network',
        subCategoryName: 'Infrastructure',
        groupId: 'Network-diagramCategory-Infrastructure',
        componentList: [],
        type: 'diagramList',
      },
      {
        categoryName: 'Network',
        subCategoryName: 'Basic',
        groupId: 'Network-diagramCategory-Basic',
        componentList: [],
        type: 'diagramList',
      },
      {
        categoryName: 'Network',
        subCategoryName: 'Cisco',
        groupId: 'Network-diagramCategory-Cisco',
        componentList: [],
        type: 'diagramList',
      },
    ],
  },
];

export const ICONS = [
  {
    categoryName: 'Action',
    groupId: 'Action-iconCategory',
    componentList: [],
    type: 'iconList',
  },
  {
    categoryName: 'Social',
    groupId: 'Social-iconCategory',
    componentList: [],
    type: 'iconList',
  },
  {
    categoryName: 'Notification',
    groupId: 'Notification-iconCategory',
    componentList: [],
    type: 'iconList',
  },
  {
    categoryName: 'Navigation',
    groupId: 'Navigation-iconCategory',
    componentList: [],
    type: 'iconList',
  },
  {
    categoryName: 'Editor',
    groupId: 'Editor-iconCategory',
    componentList: [],
    type: 'iconList',
  },
];

export const BUILT_IN_COMPONENT = {
  systemList: SYSTEMS,
  diagramList: DIAGRAMS,
  iconList: ICONS,
};

export const DIAGRAMS_HAVE_SUB_CATEGORY = ['Network'];

export const DEFAULT_SYSTEM_GROUP_IDS = [
  'Common-systemCategory',
  'Shapes-systemCategory',
  'Charts-systemCategory',
  'Devices-systemCategory',
  'IOS-systemCategory',
  'Android-systemCategory',
  'Web-systemCategory',
  'Avatar-systemCategory',
  'Bootstrap-systemCategory',
  'Ionic-systemCategory',
];

export const DEFAULT_DIAGRAM_GROUP_IDS = [
  'Flowchart-diagramCategory',
  'Shapes-diagramCategory',
  'Container-diagramCategory',
  'Network-diagramCategory',
  'Network-diagramCategory-Infrastructure',
  'Network-diagramCategory-Basic',
  'Network-diagramCategory-Cisco',
];

export const DEFAULT_ICON_GROUP_IDS = [
  'Action-iconCategory',
  'Social-iconCategory',
  'Notification-iconCategory',
  'Navigation-iconCategory',
  'Editor-iconCategory',
];
